<template>
    <div>
        <section style="height: 100%; width: 100%;">
            <div class="container reveal">

                <div class="text-container hidden-lg-and-up center-horizontal">
                    <div class="">
                        <div class="py-5"></div>
                        <div class="">
                            <h2 style="letter-spacing: 0px; font-size: 28px !important;">성적이 오를 수 밖에 없는</h2>
                            <h2 style="letter-spacing: 0px; font-size: 28px !important;"><span style="color: #A20916">IVYED</span>만의 유학 과외</h2>
                            <div class="py-1"></div>
                            <div style="color: #838397; font-size: 15px; font-weight: normal">
                                상위 1%의 과외를 받아보세요!
                            </div>
                        </div>

                    </div>
<!--                    <div class="py-10"></div>-->

                </div>
                <div class=" hidden-md-and-down text-center">
                    <div>
                        <div class="py-5"></div>
                        <div class="" >
                            <div class="font-weight-bold" style="letter-spacing: -1px; font-size: 34px !important;">성적이 오를 수 밖에 없는</div>
                            <div class="font-weight-bold" style="letter-spacing: -1px; font-size: 34px !important;"><span style="color: #A30717">IVYED</span>만의 유학 과외</div>
                            <div class="py-1"></div>
                            <div style="color: #838397; font-size: 20px; font-weight: normal">
                                상위 1%의 과외를 받아보세요!
                            </div>
                        </div>

                    </div>
                                        <div class="py-10"></div>

                </div>

            </div>

        </section>
    </div>
</template>

<script>
    export default {
        name: "GradesMustGoUp",
        mounted() {
            window.addEventListener("scroll", this.reveal);
        },
        destroyed() {
            window.removeEventListener("scroll", this.reveal);
        },
        methods: {
            reveal() {
                var reveals = document.querySelectorAll(".reveal");

                for (var i = 0; i < reveals.length; i++) {
                    var windowHeight = window.innerHeight;
                    var elementTop = reveals[i].getBoundingClientRect().top;
                    var elementVisible = 150;

                    if (elementTop < windowHeight - elementVisible) {
                        reveals[i].classList.add("active");
                    } else {
                        reveals[i].classList.remove("active");
                    }
                }
            },
        },
    };
</script>

<style>


    body {
        /*background: #42455a;*/
    }

    section {
        /*min-height: 100vh;*/
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
    }

    .each-title {
        font-size: 21px !important;
        text-align: left !important;
    }

    section:nth-child(1) {
        color: black;
    }

    section:nth-child(2) {
        color: black;
        background: #ffffff !important;
    }

    /* Add more styles for other sections as needed */
    section .container {
        /*margin: 100px;*/
        background-color: #ffffff !important;

    }

    section h1 {
        /*font-size: 3rem;*/
        /*margin: 20px;*/
    }

    section h2 {
        font-size: 40px;
        /*text-align: center;*/
        text-transform: uppercase;
    }

    section .text-container {
        display: flex;
        padding: 20px;
        margin-top: 10px;
    }

    section .text-container .text-box {
        /*margin: 20px;*/
        /*padding: 20px;*/
        /*background: #00c2cb;*/

    }

    section .text-container .text-box h3 {
        font-size: 30px;
        /*text-align: center;*/
        text-transform: uppercase;
        margin-bottom: 10px;
    }

    @media (max-width: 900px) {
        section h1 {
            font-size: 2rem;
            /*text-align: center;*/
        }

        section .text-container {
            flex-direction: column;
        }
    }

    .reveal {
        position: relative;
        transform: translateY(150px);
        opacity: 0;
        transition: 1s all ease;
    }

    .reveal.active {
        transform: translateY(0);
        opacity: 1;
    }
    .center-horizontal {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>

